//
//
//
//
//
//
//
//
//
//
//
//

import PostUserHeader from "./PostUserHeader.vue";
import PostMetaInfo from "./PostMetaInfo.vue";
import PostWork from "./PostWork.vue";
import ImagesView from "./ImagesView.vue";
import TextWap from "./TextWap.vue";

export default {
  name: "workImage",
  created() {},
  props: ["post"],
  data() {
    return {};
  },
  methods: {},
  components: {
    PostUserHeader,
    PostMetaInfo,
    PostWork,
    ImagesView,
    TextWap
  }
};



// WEBPACK FOOTER //
// ./src/components/post/PostText.vue